document.addEventListener('DOMContentLoaded', function () {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.main-nav');

  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      const open = nav.classList.toggle('mobile-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.faq').forEach(function (item) {
    item.addEventListener('toggle', function () {
      const answer = item.querySelector('.faq-answer');
      if (!answer) return;
      if (item.open) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = '0px';
      }
    });
  });
});
/* LEX homepage reveal animation */
(function(){
  if(!('IntersectionObserver' in window)) return;
  function initLexReveal(){
    var els=document.querySelectorAll('.section:not(.collection-page), .lex-benefits-premium, .lex-shipping-banner');
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('lex-reveal-visible'); io.unobserve(e.target); }
      });
    },{threshold:.08});
    els.forEach(function(el){ el.classList.add('lex-reveal'); io.observe(el); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initLexReveal);
  else initLexReveal();
})();

/* LEX Products hover/click mega menu: keep open while pointer moves into panel */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lex-products-nav').forEach(function (nav) {
    var trigger = nav.querySelector('.lex-products-trigger');
    var buttons = nav.querySelectorAll('.lex-products-category[data-mega-target]');
    var panels = nav.querySelectorAll('[data-mega-panel]');
    var mega = nav.querySelector('.lex-products-mega');
    var closeTimer = null;
    if (!trigger || !mega) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mega.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    function cancelClose() { if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; } }
    function scheduleClose() { cancelClose(); closeTimer = window.setTimeout(function(){ setOpen(false); }, 220); }
    function activate(target) {
      buttons.forEach(function (button) { button.classList.toggle('is-active', button.getAttribute('data-mega-target') === target); });
      panels.forEach(function (panel) { panel.classList.toggle('is-active', panel.id === target); });
    }
    nav.addEventListener('mouseenter', function(){ cancelClose(); setOpen(true); });
    nav.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('mouseenter', function(){ cancelClose(); setOpen(true); });
    mega.addEventListener('mouseleave', scheduleClose);
    buttons.forEach(function (button) {
      button.addEventListener('mouseenter', function () { activate(button.getAttribute('data-mega-target')); });
      button.addEventListener('focus', function () { activate(button.getAttribute('data-mega-target')); });
    });
    trigger.addEventListener('click', function (event) { event.preventDefault(); cancelClose(); setOpen(!nav.classList.contains('is-open')); });
    document.addEventListener('click', function (event) { if (!nav.contains(event.target)) setOpen(false); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setOpen(false); });
    activate(nav.querySelector('.lex-products-category.is-active')?.getAttribute('data-mega-target') || (buttons[0] && buttons[0].getAttribute('data-mega-target')));
  });
});

/* LEX collection filter/sort controls */
document.addEventListener('DOMContentLoaded',function(){
  var form=document.getElementById('CollectionFilterForm');
  if(form){
    var all=form.querySelector('[data-all-category]');
    var cats=form.querySelectorAll('[data-category-handle]');
    var params=new URLSearchParams(location.search);
    var selected=(params.get('categories')||'').split(',').filter(Boolean).slice(0,1);
    function sync(){
      cats.forEach(function(i){
        var on=selected.indexOf(i.value)>-1;
        i.checked=on;
        var l=i.closest('label');
        if(l)l.classList.toggle('is-active',on);
      });
      if(all){
        var aon=!selected.length;
        all.checked=aon;
        var al=all.closest('label');
        if(al)al.classList.toggle('is-active',aon);
      }
    }
    sync();
    cats.forEach(function(i){i.addEventListener('change',function(){
      selected=i.checked?[i.value]:[];
      sync();
    });});
    if(all)all.addEventListener('change',function(){
      if(this.checked){selected=[];sync();}
    });
    form.addEventListener('submit',function(){
      var hidden=form.querySelector('input[name="categories"]');
      if(hidden)hidden.remove();
      if(selected.length){
        hidden=document.createElement('input');
        hidden.type='hidden';hidden.name='categories';hidden.value=selected[0];
        form.appendChild(hidden);
        form.action='/collections/all';
      }else{form.action=form.getAttribute('data-default-action')||'/collections/all';}
    });
  }
  var category=(new URLSearchParams(location.search).get('categories')||'').split(',').filter(Boolean)[0];
  if(category){
    var cards=document.querySelectorAll('.collection-results .product-card'),shown=0;
    cards.forEach(function(card){
      var list=(card.getAttribute('data-category-handles')||'').split(',').filter(Boolean);
      var ok=list.indexOf(category)>-1;
      card.hidden=!ok;if(ok)shown++;
    });
    var count=document.getElementById('CollectionResultCount');
    if(count)count.textContent=shown;
    var empty=document.querySelector('.collection-results .empty-state');
    if(!shown&&!empty){
      empty=document.createElement('div');empty.className='empty-state';
      empty.innerHTML='<h2>Seçtiğiniz kategoride ürün bulunamadı.</h2><a class="btn" href="'+location.pathname+'">Filtreleri Temizle</a>';
      document.querySelector('.collection-results').appendChild(empty);
    }
  }
});

/* LEX detailed filter search */
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-filter-search]').forEach(function(input){input.addEventListener('input',function(){var q=this.value.toLowerCase().trim(),box=this.closest('.filter-options');if(!box)return;box.querySelectorAll('[data-filter-item]').forEach(function(item){item.classList.toggle('is-hidden',q!=='' && item.textContent.toLowerCase().indexOf(q)===-1);});});});
  document.querySelectorAll('[data-tag-search]').forEach(function(input){input.addEventListener('input',function(){var q=this.value.toLowerCase().trim(),box=this.closest('.filter-options');if(!box)return;box.querySelectorAll('[data-tag-item]').forEach(function(item){item.classList.toggle('is-hidden',q!=='' && item.textContent.toLowerCase().indexOf(q)===-1);});});});
});

/* LEX advanced collection sort (delegated: AJAX ile yenilense de çalışır) */
document.addEventListener('click',function(e){
  var closeAll=function(except){document.querySelectorAll('[data-sort-control].is-open').forEach(function(b){if(b===except)return;b.classList.remove('is-open');var t=b.querySelector('.lex-sort-trigger');if(t)t.setAttribute('aria-expanded','false');});};
  var trig=e.target.closest&&e.target.closest('.lex-sort-trigger');
  if(trig){var box=trig.closest('[data-sort-control]');closeAll(box);var open=box.classList.toggle('is-open');trig.setAttribute('aria-expanded',open?'true':'false');return;}
  var opt=e.target.closest&&e.target.closest('.lex-sort-option');
  if(opt){
    if(window.LexCollection){window.LexCollection.setSort(opt.dataset.sortValue);}
    else{var u=new URL(window.location.href);u.searchParams.set('sort_by',opt.dataset.sortValue);window.location.href=u.toString();}
    return;
  }
  closeAll(null);
});

/* LEX loop carousel — elle kaydırma (dokunma / trackpad / mouse sürükleme / oklar), kesintisiz sonsuz döngü, otomatik kayma YOK */
(function(){
  function Loop(root){
    var vp=root.querySelector('.lex-loop__viewport'), track=root.querySelector('.lex-loop__track');
    var prevBtn=root.querySelector('.lex-loop__btn--prev'), nextBtn=root.querySelector('.lex-loop__btn--next');
    if(!vp||!track) return;
    var originals=[].slice.call(track.children);
    if(!originals.length) return;
    var mainStart=0,setW=0,pitch=0,gap=0,lastW=0,settleTimer=null,resizeTimer=null,touching=false;

    function makeClone(el){
      var c=el.cloneNode(true);
      c.setAttribute('data-clone','');c.setAttribute('aria-hidden','true');
      [].forEach.call(c.querySelectorAll('a,button'),function(a){a.setAttribute('tabindex','-1')});
      [].forEach.call(c.querySelectorAll('img'),function(i){i.setAttribute('draggable','false')});
      return c;
    }
    function jump(x){
      vp.style.scrollSnapType='none';
      vp.scrollLeft=x;
      vp.style.scrollSnapType='';
    }
    function build(keepLogical){
      var vw=vp.clientWidth;
      if(!vw) return;
      var n=originals.length, logical=0;
      if(keepLogical&&pitch&&setW){logical=((Math.round((vp.scrollLeft-mainStart)/pitch)%n)+n)%n}
      [].slice.call(track.querySelectorAll('[data-clone]')).forEach(function(c){c.parentNode.removeChild(c)});
      var cs=getComputedStyle(track);
      gap=parseFloat(cs.columnGap||cs.gap)||0;
      pitch=originals[0].getBoundingClientRect().width+gap;
      // Bir "set" en az görünür alanın 1.5 katı kadar olsun -> hiçbir zaman boşluk kalmaz
      var r=Math.max(1,Math.ceil(vw*1.5/(n*pitch)));
      var main=document.createDocumentFragment(),pre=document.createDocumentFragment(),post=document.createDocumentFragment(),k;
      for(k=1;k<r;k++) originals.forEach(function(o){main.appendChild(makeClone(o))});
      for(k=0;k<r;k++) originals.forEach(function(o){pre.appendChild(makeClone(o));post.appendChild(makeClone(o))});
      track.appendChild(main);
      track.insertBefore(pre,track.firstChild);
      track.appendChild(post);
      var kids=track.children;
      mainStart=kids[r*n].offsetLeft;
      setW=kids[2*r*n].offsetLeft-mainStart;
      jump(mainStart+logical*pitch);
    }
    function normalize(){
      if(touching||!setW) return;
      var s=vp.scrollLeft,guard=0;
      while(s<mainStart-1&&guard++<5){s+=setW;jump(s)}
      while(s>=mainStart+setW-1&&guard++<5){s-=setW;jump(s)}
    }
    function onScroll(){
      if(!setW) return;
      var s=vp.scrollLeft,max=vp.scrollWidth-vp.clientWidth;
      // kenara çok yaklaşıldıysa beklemeden içeri al
      if(s<=2){jump(s+setW);return}
      if(s>=max-2){jump(s-setW);return}
      clearTimeout(settleTimer);settleTimer=setTimeout(normalize,140);
    }
    function step(dir){
      normalize();
      var visible=Math.max(1,Math.floor((vp.clientWidth+gap)/pitch));
      vp.scrollBy({left:dir*visible*pitch,behavior:'smooth'});
    }
    if(prevBtn)prevBtn.addEventListener('click',function(){step(-1)});
    if(nextBtn)nextBtn.addEventListener('click',function(){step(1)});
    vp.addEventListener('scroll',onScroll,{passive:true});
    vp.addEventListener('touchstart',function(){touching=true},{passive:true});
    vp.addEventListener('touchend',function(){touching=false;clearTimeout(settleTimer);settleTimer=setTimeout(normalize,180)},{passive:true});
    vp.addEventListener('touchcancel',function(){touching=false},{passive:true});

    // Mouse ile sürükleyerek kaydırma (masaüstü)
    var down=false,moved=false,dragged=false,sx=0,sl=0;
    vp.addEventListener('pointerdown',function(e){
      if(e.pointerType!=='mouse'||e.button!==0) return;
      down=true;moved=false;sx=e.clientX;sl=vp.scrollLeft;
    });
    window.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-sx;
      if(!moved&&Math.abs(dx)>5){moved=true;touching=true;root.classList.add('is-dragging')}
      if(moved) vp.scrollLeft=sl-dx;
    });
    function endDrag(){
      if(!down) return;
      down=false;
      if(moved){
        root.classList.remove('is-dragging');touching=false;
        dragged=true;setTimeout(function(){dragged=false},0);
        var idx=Math.round(vp.scrollLeft/pitch);
        vp.scrollTo({left:idx*pitch,behavior:'smooth'});
        clearTimeout(settleTimer);settleTimer=setTimeout(normalize,500);
      }
    }
    window.addEventListener('pointerup',endDrag);
    window.addEventListener('pointercancel',endDrag);
    vp.addEventListener('dragstart',function(e){e.preventDefault()});
    vp.addEventListener('click',function(e){if(dragged){e.preventDefault();e.stopPropagation()}},true);

    // Ürün tıklama olayı (analitik)
    root.addEventListener('click',function(e){
      var slide=e.target.closest&&e.target.closest('[data-product-handle]');
      if(!slide||!e.target.closest('.product-card')) return;
      try{
        if(window.Shopify&&window.Shopify.analytics&&window.Shopify.analytics.publish){
          window.Shopify.analytics.publish('lex_product_click',{handle:slide.getAttribute('data-product-handle'),productId:slide.getAttribute('data-product-id')});
        }
      }catch(err){}
    },true);

    // Otomatik tek tek kayma: fare üstündeyken, dokunurken, odaktayken, sekme gizliyken
    // veya ekranda görünmüyorken durur; kullanıcı müdahale edince süre sıfırlanır.
    var autoMs=parseInt(root.getAttribute('data-autoplay')||'0',10);
    var autoOffset=parseInt(root.getAttribute('data-autoplay-offset')||'0',10);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(autoMs>0&&!reduce){
      var hovering=false,focused=false,visible=true,autoTimer=null;
      function canRun(){return !hovering&&!focused&&!touching&&!down&&visible&&!document.hidden}
      function schedule(delay){
        clearTimeout(autoTimer);
        autoTimer=setTimeout(function(){
          if(canRun()){normalize();vp.scrollBy({left:pitch,behavior:'smooth'})}
          schedule(autoMs);
        },delay);
      }
      root.addEventListener('mouseenter',function(){hovering=true});
      root.addEventListener('mouseleave',function(){hovering=false;schedule(autoMs)});
      root.addEventListener('focusin',function(){focused=true});
      root.addEventListener('focusout',function(){focused=false;schedule(autoMs)});
      vp.addEventListener('touchend',function(){schedule(autoMs+1500)},{passive:true});
      if(prevBtn)prevBtn.addEventListener('click',function(){schedule(autoMs+1500)});
      if(nextBtn)nextBtn.addEventListener('click',function(){schedule(autoMs+1500)});
      if(window.IntersectionObserver){new IntersectionObserver(function(en){visible=en[0].isIntersecting}).observe(root)}
      document.addEventListener('visibilitychange',function(){if(!document.hidden)schedule(autoMs)});
      schedule(autoMs+autoOffset);
    }

    // Ekran boyutu değişince yeniden kur (görünen kart sayısı değişir)
    function onResize(){
      var w=vp.clientWidth;
      if(w===lastW) return;
      lastW=w;
      clearTimeout(resizeTimer);resizeTimer=setTimeout(function(){build(true)},120);
    }
    if(window.ResizeObserver){new ResizeObserver(onResize).observe(vp)}else{window.addEventListener('resize',onResize)}
    lastW=vp.clientWidth;
    build(false);
  }
  function init(){
    document.querySelectorAll('[data-lex-loop]').forEach(function(root){
      if(root.dataset.lexReady==='1') return;
      root.dataset.lexReady='1';
      Loop(root);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

/* LEX collection filters — anında filtreleme (AJAX), fiyat aralığı çubuğu, aktif filtre çipleri, mobil çekmece */
(function(){
  var page=document.querySelector('.collection-page');
  var aside=document.getElementById('LexFilters');
  if(!page||!aside||!window.fetch||!window.URLSearchParams||!window.DOMParser) return;
  var overlay=document.querySelector('.lex-f-overlay');
  var openBtn=document.querySelector('[data-filter-open]');
  var ctrl=null,reqId=0,timer=null;

  function $(s,c){return (c||document).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function curSort(){return new URLSearchParams(location.search).get('sort_by')||''}
  function isMobile(){return window.matchMedia('(max-width: 900px)').matches}

  /* ---- URL: formdaki seçimler + mevcut sıralama ---- */
  function buildUrl(){
    var f=$('#LexFilterForm',aside),p=new URLSearchParams();
    if(f){new FormData(f).forEach(function(v,k){v=String(v).trim();if(v!=='')p.append(k,v)})}
    var s=curSort();if(s)p.set('sort_by',s);
    var q=p.toString();
    return location.pathname+(q?'?'+q:'');
  }

  /* ---- Sayfa parçalarını yenile ---- */
  function swap(name,doc){
    var a=$('[data-lex-swap="'+name+'"]'),b=$('[data-lex-swap="'+name+'"]',doc);
    if(a&&b){a.innerHTML=b.innerHTML;a.hidden=b.hidden}
  }
  function patchCounts(doc){
    var map={};
    $$('[data-key]',aside).forEach(function(el){map[el.getAttribute('data-key')]=el});
    $$('[data-key]',doc).forEach(function(n){
      var el=map[n.getAttribute('data-key')];if(!el)return;
      var s=$('small',el),ns=$('small',n);if(s&&ns)s.textContent=ns.textContent;
      var dis=n.classList.contains('is-disabled');
      el.classList.toggle('is-disabled',dis);
      var inp=$('input',el);if(inp&&!inp.checked)inp.disabled=dis;
    });
  }
  function apply(doc,mode){
    if(!$('[data-lex-swap="results"]',doc))throw new Error('unexpected response');
    ['results','meta','sort','head-actions','badge','apply'].forEach(function(n){swap(n,doc)});
    if(mode==='nav'){
      var open={},sy=aside.scrollTop;
      $$('details[data-group]',aside).forEach(function(d){open[d.getAttribute('data-group')]=d.open});
      swap('title',doc);swap('panel',doc);
      $$('details[data-group]',aside).forEach(function(d){var k=d.getAttribute('data-group');if(k in open)d.open=open[k]});
      aside.scrollTop=sy;
      if(doc.title)document.title=doc.title;
      var np=$('.collection-page',doc);
      if(np)page.setAttribute('data-collection-handle',np.getAttribute('data-collection-handle')||'');
      initPrice();
    }else{
      patchCounts(doc);
    }
  }
  function load(url,mode,push,scroll){
    if(ctrl)ctrl.abort();
    ctrl=new AbortController();
    var id=++reqId;
    page.classList.add('is-loading');
    return fetch(url,{signal:ctrl.signal,credentials:'same-origin',headers:{'X-Requested-With':'fetch'}})
      .then(function(r){if(!r.ok)throw new Error(r.status);return r.text()})
      .then(function(html){
        if(id!==reqId)return;
        var doc=new DOMParser().parseFromString(html,'text/html');
        apply(doc,mode);
        if(push!==false)history.pushState({lex:1},'',url);
        page.classList.remove('is-loading');
        if(scroll){var t=$('.lex-toolbar',page);if(t)t.scrollIntoView({behavior:'smooth',block:'start'})}
      })
      .catch(function(err){
        if(err&&err.name==='AbortError')return;
        page.classList.remove('is-loading');
        window.location.href=url;
      });
  }
  function schedule(ms){clearTimeout(timer);timer=setTimeout(function(){load(buildUrl(),'form',true)},ms)}

  /* ---- Fiyat aralığı çubuğu ---- */
  function initPrice(){
    var box=$('[data-price]',aside);if(!box)return;
    var max=parseFloat(box.getAttribute('data-max'))||0;
    var nMin=$('[data-price-min]',box),nMax=$('[data-price-max]',box);
    var rMin=$('[data-range-min]',box),rMax=$('[data-range-max]',box),wrap=$('.lex-range',box);
    if(!rMin||!rMax||!wrap||max<1)return;
    function paint(){
      var lo=+rMin.value,hi=+rMax.value;
      wrap.style.setProperty('--lo',(lo/max*100)+'%');
      wrap.style.setProperty('--hi',(hi/max*100)+'%');
      rMin.style.zIndex=(lo>max*0.85)?5:3;
    }
    function fromRanges(src){
      var lo=+rMin.value,hi=+rMax.value;
      if(lo>hi){if(src===rMin){lo=hi;rMin.value=lo}else{hi=lo;rMax.value=hi}}
      nMin.value=lo>0?lo:'';nMax.value=hi<max?hi:'';
      paint();
    }
    function fromNumbers(){
      var lo=nMin.value===''?0:Math.max(0,Math.min(max,parseFloat(nMin.value)||0));
      var hi=nMax.value===''?max:Math.max(0,Math.min(max,parseFloat(nMax.value)||0));
      if(lo>hi){var t=lo;lo=hi;hi=t}
      nMin.value=lo>0?lo:'';nMax.value=hi<max?hi:'';
      rMin.value=lo;rMax.value=hi;paint();
    }
    rMin.addEventListener('input',function(){fromRanges(rMin)});
    rMax.addEventListener('input',function(){fromRanges(rMax)});
    nMin.addEventListener('change',fromNumbers);
    nMax.addEventListener('change',fromNumbers);
    paint();
  }

  /* ---- Listelerde arama ---- */
  function filterList(input){
    var q=input.value.toLowerCase().trim(),body=input.closest('.lex-f-body');if(!body)return;
    $$('[data-f-item]',body).forEach(function(i){i.hidden=!!q&&i.textContent.toLowerCase().indexOf(q)<0});
  }

  /* ---- Mobil çekmece ---- */
  function openDrawer(){
    aside.classList.add('is-open');if(overlay)overlay.hidden=false;
    document.documentElement.classList.add('lex-f-lock');
    if(openBtn)openBtn.setAttribute('aria-expanded','true');
  }
  function closeDrawer(){
    aside.classList.remove('is-open');if(overlay)overlay.hidden=true;
    document.documentElement.classList.remove('lex-f-lock');
    if(openBtn)openBtn.setAttribute('aria-expanded','false');
  }

  /* ---- Olaylar ---- */
  aside.addEventListener('change',function(e){
    var t=e.target;
    if(t.matches('#LexFilterForm input[type=checkbox]'))schedule(120);
    else if(t.matches('[data-price-min],[data-price-max]'))schedule(250);
  });
  aside.addEventListener('input',function(e){
    var t=e.target;
    if(t.matches('[data-range-min],[data-range-max]'))schedule(500);
    else if(t.matches('[data-f-search]'))filterList(t);
  });
  aside.addEventListener('submit',function(e){
    e.preventDefault();clearTimeout(timer);
    load(buildUrl(),'form',true);
    if(isMobile())closeDrawer();
  });
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[data-lex-ajax]');
    if(a&&!(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)){
      var u;try{u=new URL(a.href,location.href)}catch(x){u=null}
      if(u&&u.origin===location.origin){
        e.preventDefault();
        var s=curSort();
        if(a.hasAttribute('data-keep-sort')&&s&&!u.searchParams.has('sort_by'))u.searchParams.set('sort_by',s);
        load(u.pathname+u.search,'nav',true,a.hasAttribute('data-scroll'));
        if(a.classList.contains('lex-f-cat')&&isMobile())closeDrawer();
        return;
      }
    }
    if(e.target.closest&&e.target.closest('[data-filter-open]')){openDrawer();return}
    if(e.target.closest&&e.target.closest('[data-filter-close]')){closeDrawer();return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer()});
  window.addEventListener('resize',function(){if(!isMobile())closeDrawer()});
  window.addEventListener('popstate',function(){load(location.pathname+location.search,'nav',false)});

  window.LexCollection={
    load:load,
    setSort:function(v){
      var u=new URL(location.href);
      u.searchParams.set('sort_by',v);u.searchParams.delete('page');
      load(u.pathname+u.search,'form',true);
    }
  };
  initPrice();
})();

/* ===== edekor: imleç izi + tıklama efekti + buton efektleri ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var BTN = '.btn,.lex-hero-btn,.lex-add-cart,.lex-checkout,.lex-404-primary,.lex-404-secondary,.lex-shipping-btn,.lex-card-cta,.lex-offer-button,.lex-f-submit,button[type="submit"]';

  /* --- Buton efektleri (parlama + dalga) --- */
  function prepBtn(b) {
    if (b.dataset.lexFx) return;
    b.dataset.lexFx = '1';
    b.classList.add('lex-fx-btn');
    var s = document.createElement('i');
    s.className = 'lex-fx-shine';
    s.setAttribute('aria-hidden', 'true');
    b.appendChild(s);
  }
  function scan(root) { (root || document).querySelectorAll(BTN).forEach(prepBtn); }
  scan();
  if (window.MutationObserver) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { scan(); break; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (reduce) return;

  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.lex-fx-btn');
    if (!b) return;
    var r = b.getBoundingClientRect(), k = (b.offsetWidth ? r.width / b.offsetWidth : 1) || 1;
    var d = Math.max(b.offsetWidth, b.offsetHeight) * 2;
    var rip = document.createElement('span');
    rip.className = 'lex-fx-ripple';
    rip.style.width = rip.style.height = d + 'px';
    rip.style.left = ((e.clientX - r.left) / k - d / 2) + 'px';
    rip.style.top = ((e.clientY - r.top) / k - d / 2) + 'px';
    b.appendChild(rip);
    setTimeout(function () { rip.remove(); }, 1100);
  }, { passive: true });

  /* --- Canvas: imleç izi ve tıklama patlaması --- */
  var canvas = document.createElement('canvas');
  canvas.className = 'lex-fx-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  /* body'ye zoom uygulandığı için tuvali <html> altına koyuyoruz ve ölçeği düzeltiyoruz */
  document.documentElement.appendChild(canvas);
  var ctx = canvas.getContext('2d'), W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function resize() {
    W = window.innerWidth; H = window.innerHeight;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    var rc = canvas.getBoundingClientRect(), k = rc.width / W;
    if (k && Math.abs(k - 1) > .01) { canvas.style.width = (W / k) + 'px'; canvas.style.height = (H / k) + 'px'; }
    canvas.width = W * dpr; canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  var COLORS = ['0,195,52', '60,230,110', '140,255,180'];
  var P = [], rings = [], running = false, lastX = -99, lastY = -99;

  function start() { if (!running) { running = true; requestAnimationFrame(frame); } }

  function trail(x, y) {
    var dx = x - lastX, dy = y - lastY;
    if (dx * dx + dy * dy < 36) return;
    lastX = x; lastY = y;
    P.push({
      x: x, y: y, vx: (Math.random() - .5) * .35, vy: (Math.random() - .5) * .35 + .08,
      r: 3 + Math.random() * 3.5, life: 1, decay: .011 + Math.random() * .006,
      c: COLORS[(Math.random() * COLORS.length) | 0], t: 'dot'
    });
    if (P.length > 200) P.splice(0, P.length - 140);
    start();
  }

  function burst(x, y) {
    for (var i = 0; i < 16; i++) {
      var a = (Math.PI * 2 * i) / 16 + Math.random() * .3, v = 1.2 + Math.random() * 2;
      P.push({
        x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, r: 2.5 + Math.random() * 3,
        life: 1, decay: .012 + Math.random() * .006, c: COLORS[(Math.random() * COLORS.length) | 0],
        t: i % 4 === 0 ? 'star' : 'dot', g: .02
      });
    }
    rings.push({ x: x, y: y, r: 4, life: 1 });
    start();
  }

  function star(x, y, r) {
    ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var rad = i % 2 ? r * .45 : r * 1.4, a = (Math.PI / 4) * i - Math.PI / 2;
      ctx.lineTo(x + Math.cos(a) * rad, y + Math.sin(a) * rad);
    }
    ctx.closePath(); ctx.fill();
  }

  function frame() {
    ctx.clearRect(0, 0, W, H);
    var i, p;
    for (i = P.length - 1; i >= 0; i--) {
      p = P[i];
      p.x += p.vx; p.y += p.vy; if (p.g) p.vy += p.g;
      p.vx *= .99; p.life -= p.decay;
      if (p.life <= 0) { P.splice(i, 1); continue; }
      ctx.fillStyle = 'rgba(' + p.c + ',' + (p.life * .85).toFixed(3) + ')';
      ctx.shadowColor = 'rgba(' + p.c + ',.8)'; ctx.shadowBlur = 10;
      if (p.t === 'star') star(p.x, p.y, p.r * p.life + .5);
      else { ctx.beginPath(); ctx.arc(p.x, p.y, Math.max(p.r * p.life, .3), 0, 6.2832); ctx.fill(); }
    }
    ctx.shadowBlur = 0;
    for (i = rings.length - 1; i >= 0; i--) {
      var g = rings[i];
      g.r += 1.6; g.life -= .02;
      if (g.life <= 0) { rings.splice(i, 1); continue; }
      ctx.strokeStyle = 'rgba(0,195,52,' + (g.life * .7).toFixed(3) + ')';
      ctx.lineWidth = 2 * g.life + .5;
      ctx.beginPath(); ctx.arc(g.x, g.y, g.r, 0, 6.2832); ctx.stroke();
    }
    if (P.length || rings.length) requestAnimationFrame(frame); else running = false;
  }

  if (fine) {
    window.addEventListener('mousemove', function (e) { trail(e.clientX, e.clientY); }, { passive: true });
  }
  window.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button > 0) return;
    burst(e.clientX, e.clientY);
  }, { passive: true });
})();

/* ===== edekor: sepet zıplaması + kaydırınca beliren bölümler ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Sepet ikonu --- */
  function cartEl() { return document.querySelector('.cart-icon'); }
  function bump() {
    var c = cartEl(); if (!c || reduce) return;
    c.classList.remove('lex-cart-bump'); void c.offsetWidth; c.classList.add('lex-cart-bump');
    setTimeout(function () { c.classList.remove('lex-cart-bump'); }, 1000);
  }
  function count() { var b = document.querySelector('.cart-icon b'); return b ? parseInt(b.textContent, 10) || 0 : 0; }
  try {
    var prev = sessionStorage.getItem('lexCartCount'), now = count();
    if (prev !== null && now > parseInt(prev, 10)) setTimeout(bump, 350);
    sessionStorage.setItem('lexCartCount', String(now));
  } catch (e) {}
  /* Sayfa yenilemeden sepete ekleme (varsa) */
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (u) {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) {
        p.then(function (r) {
          if (r && r.ok && /\/cart\/add/.test(url)) {
            bump();
            of('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
              var b = document.querySelector('.cart-icon b'); if (b) b.textContent = c.item_count;
              try { sessionStorage.setItem('lexCartCount', String(c.item_count)); } catch (e) {}
            }).catch(function () {});
          }
        }).catch(function () {});
      }
      return p;
    };
  }
  /* Ürün formu normal gönderimle sepete gidiyorsa, tıklanınca butonu da canlandır */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) {
      var b = f.querySelector('[type="submit"]');
      if (b && !reduce) { b.classList.add('lex-fx-btn'); }
    }
  });

  /* --- Kaydırınca beliren bölümler --- */
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('lex-js');
  var targets = document.querySelectorAll('#MainContent > section:not(.lex-home-hero):not(.lex-hero2), #MainContent > div > section:not(.lex-home-hero):not(.lex-hero2), .site-footer, footer.footer, footer');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('lex-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  var vh = window.innerHeight;
  targets.forEach(function (el) {
    el.classList.add('lex-reveal');
    var r = el.getBoundingClientRect();
    if (r.top < vh * 0.9) { requestAnimationFrame(function () { el.classList.add('lex-in'); }); }
    else io.observe(el);
  });
  /* Hızlı kaydırma / bağlantıyla atlama: ekranın üstünde kalan bölümleri de göster */
  var tk = false;
  window.addEventListener('scroll', function () {
    if (tk) return; tk = true;
    setTimeout(function () {
      tk = false;
      document.querySelectorAll('.lex-reveal:not(.lex-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < 0) { el.classList.add('lex-in'); io.unobserve(el); }
      });
    }, 120);
  }, { passive: true });
  /* Güvenlik: bir şey takılırsa 4 sn sonra hepsini göster */
  setTimeout(function () { document.querySelectorAll('.lex-reveal:not(.lex-in)').forEach(function (el) {
    var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('lex-in'); }); }, 4000);
})();
